import { React, useState } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import makeAsyncScriptLoader from 'react-async-script';
import { AddressSearchBar } from './AddressSearchBar';

const url = `https://maps.googleapis.com/maps/api/js?key=${process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY}&libraries=places`;

const Wrapper = ({ isActive, ...props }) => {
  if (!isActive || !window?.google?.maps?.places) {
    return null;
  }
  return <AddressSearchBar {...props} />;
};

export const AddressSearchBarWithGoogleMapScript = ({
  onSelect,
  value,
  smartyStreetsApiKey,
}) => {
  const [isActive, setActive] = useState(false);
  const AsyncGoogleMap = makeAsyncScriptLoader(url, {
    globalName: 'google',
  })(Wrapper);
  return (
    <AsyncGoogleMap
      isActive={isActive}
      onSelect={onSelect}
      smartyStreetsApiKey={smartyStreetsApiKey}
      value={value}
      asyncScriptOnLoad={() => setActive(true)}
    />
  );
};

AddressSearchBarWithGoogleMapScript.propTypes = {
  value: PropTypes.string,
  onSelect: PropTypes.func,
  smartyStreetsApiKey: PropTypes.string,
};
